var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.$data.$_componentName,_vm._b({tag:"component",attrs:{"shows":_vm.$data.$_shows,"finalize-callback":_vm.$data.$_finalizeCallback}},'component',_vm.$data.$_props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }